module.exports = __webpack_public_path__ + "static/media/pratik.93f49d29.PNG";